import { APPLICATION_URL } from '@/app-config';
import { IMondayContext } from '@/types/response/monday/context';
import mondaySdk from 'monday-sdk-js';
import { isElectron } from './common';

export const monday = mondaySdk();

const isMobileMode = (mode?: string) => mode === 'mobile';

export const openLinkInModal = async ({
  url,
  mode,
}: {
  url: string;
  mode?: string;
}) => {
  if (isMobileMode(mode)) {
    return openLinkInTab({ url });
  }

  try {
    return await monday.execute('openAppFeatureModal', {
      url,
      width: 1200,
      height: 900,
    });
  } catch (error) {
    console.log(error);
  }
};

export const openAuthenticate = async (context: IMondayContext) => {
  const url = `${APPLICATION_URL}/authenticate?context=${encodeURIComponent(
    JSON.stringify(context),
  )}`;

  if (isElectron() || isMobileMode(context.mode)) {
    return openLinkInTab({ url });
  }

  try {
    return await monday.execute('openAppFeatureModal', {
      url,
      width: '90vw',
      height: '85vh',
    });
  } catch (error) {
    console.log(error);
  }
};

export const openLinkInTab = async ({ url }: { url: string }) => {
  try {
    return await monday.execute('openLinkInTab', {
      url,
    });
  } catch (error) {
    console.log(error);
  }
};

export const showToast = async ({
  message,
  type,
  timeout = 5000,
}: {
  message: string;
  type: string;
  timeout?: number;
}) => {
  try {
    return await monday.execute('notice', {
      message,
      type,
      timeout,
    });
  } catch (error) {
    console.log(error);
  }
};
